import { Box, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Switch } from '@room-match/shared-ui-components';
import { ProfileListSkeletonContainer } from './ProfileListSkeletonStyles';

export const ProfileListSkeleton = () => {
  return (
    <ProfileListSkeletonContainer>
      <Grid container alignItems="center" spacing={2} justifyContent="space-between">
        <Grid item xs={12} lg={2} style={{ display: 'flex', gap: 10 }}>
          <Box style={{ aspectRatio: '3/4', width: '80px' }}>
            <Skeleton variant="rect" width={'100%'} height={'100%'} style={{ borderRadius: '5px' }} />
          </Box>
          <Box alignSelf={'end'}>
            <Skeleton variant="text" width={100} height={24} />
            <Box style={{ display: 'flex', marginLeft: -18, alignItems: 'center' }}>
              <Switch checked={false} toggle={() => {}} disabled />
              <Skeleton variant="text" width={50} height={24} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={3}>
          <Skeleton variant="rect" width={'100%'} height={50} style={{ borderRadius: 8 }} />
        </Grid>
      </Grid>
    </ProfileListSkeletonContainer>
  );
};

export const ProfileListSkeletonMulti = () => {
  const loadingArr = new Array(3).fill('');

  return (
    <Grid container spacing={1}>
      {loadingArr?.map((loading, index) => (
        <Grid item xs={12} key={index}>
          <ProfileListSkeleton />
        </Grid>
      ))}
    </Grid>
  );
};
